import { get } from 'lodash';
import {loadApplicantProfileInfo, loadRestofApplicantProfileInfo} from '../../redux/actionCreators/async';

export default function OnEnterLoadApplicantProfile(store) {
  return (nextState, replace, done) => {
    const {
      user,
    } = store.getState();

    const roles = get(user, 'roles', []);
    const impersontationId = get(user, 'impersonateUser.profileId');
    const applicantId = get(user, 'profileId');
    if (roles.includes('Applicant')) {
      store.dispatch(loadApplicantProfileInfo(applicantId))
      .then(() => store.dispatch(loadRestofApplicantProfileInfo(applicantId)));
    }
    else {
      store.dispatch(loadApplicantProfileInfo(impersontationId))
      .then(() => store.dispatch(loadRestofApplicantProfileInfo(impersontationId)));
    }

    done();
  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadApplicantProfile.js